export { renderCardFooter_unstable as renderCardFooter } from '@fluentui/react-card';
